import { useQuery } from "@tanstack/react-query";

import { calculateCoverCropMixes } from "services";

import { useTranslation } from "utils";

import { CALCULATE_COVER_CROP_MIXES } from "consts";

import { CropMixComposerGoalResponse } from "models";

export const useCalculateCoverCropMixes = ({ cropMixId }: { cropMixId: string | undefined }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  return useQuery<CropMixComposerGoalResponse[]>({
    queryKey: [CALCULATE_COVER_CROP_MIXES, cropMixId],
    queryFn: async () => {
      if (!cropMixId) return [];

      const response = await calculateCoverCropMixes({ cropMixId });
      return response.map((cmcResponse) => ({ ...cmcResponse, crop: { ...cmcResponse.crop, name: t(`crops.${cmcResponse.crop.translationSlug}`) } })) || [];
    },
  });
};
